module.exports = __webpack_public_path__ + "img/093.12fdaeec.png";